/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EloquaService {

  private listCache: any[] = [];
  private cdoListCache: any[] = [];
  private fieldCache: any[] = [];
  private cdoFieldCache: any[] = [];

  constructor(private http: HttpClient) { }

  getFields(): Observable<any> {
    if (this.fieldCache.length > 0) {
      return Observable.of(this.fieldCache);
    }

    return this.http
      .get(
      `/api/v1/eloqua/fields`
      )
      .map((response: any) => {
        this.fieldCache = response || [];
        return this.fieldCache;
      });;
  }

  getCdoFields(cdoId): Observable<any> {
    if (this.cdoFieldCache.length > 0) {
      return Observable.of(this.cdoFieldCache);
    }

    return this.http
      .get(
      `/api/v1/eloqua/cdofields?cdoId=${cdoId}`
      )
      .map((response: any) => {
        this.cdoFieldCache = response || [];
        return this.cdoFieldCache;
      });;
  }

  getLists(useCache: string = 'true'): Observable<any> {

    return this.http
      .get(
      `/api/v1/eloqua/lists?cache=${useCache}`
      );
  }

  getCdoLists(): Observable<any> {
    if (this.cdoListCache.length > 0) {
      return Observable.of(this.cdoListCache);
    }

    return this.http
      .get(
      `/api/v1/eloqua/cdolists`
      )
      .map((response: any) => {
        this.cdoListCache = response || [];
        return this.cdoListCache;
      });
  }

  searchEmail(accountId: string, emailAddress: string) {
    return this.http.post(
      `/api/v1/admin/eloqua/findemail`,
      JSON.stringify({ accountId: accountId, emailAddress: emailAddress })
    );
  }

  grantAccess(code): Observable<any> {
    return this.http
      .post(
      `/api/v1/eloqua/grant`,
      { code: code }
      );
  }

  clearListCache() {
    this.listCache = [];
  }

  clearCdoListCache() {
    this.cdoListCache = [];
  }

  clearFieldCache() {
    this.fieldCache = [];
  }

  clearCdoFieldCache() {
    this.cdoFieldCache = [];
  }

  clearAll() {
    this.listCache = [];
    this.fieldCache = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/eloqua.service.ts